import type { ClientCase } from './clientCases'

// Cases van maatwerk webapplicaties. Alleen feiten die de klant zelf heeft
// aangeleverd; geen cijfers of resultaten die we niet kunnen onderbouwen.
export const webappCases: ClientCase[] = [
  {
    slug: 'hulphondenforum',
    clientName: 'Hulphondenforum',
    sector: 'Webapplicatie',
    shortDescription:
      'Een app waarin oud-dienders van de politie met PTSS en een hulphond met elkaar in contact blijven en hun vragen kwijt kunnen.',
    heroImage:
      'https://cdn.magicpatterns.com/uploads/tYBd8gVxwuDovpJ3efqvfT/logo_alleen_hond.png',
    heroImageContain: true,
    metaDescription:
      'Lees hoe Noord Digital voor Hulphondenforum een app bouwde waarin oud-dienders van de politie met PTSS en een hulphond contact houden en vragen stellen.',
    isPrivate: true,
    status: 'live',
    content: [
      {
        type: 'paragraph',
        content:
          'Hulphondenforum is er voor oud-dienders van de politie met PTSS die een hulphond hebben. Voor deze groep is contact met mensen die hetzelfde meemaken waardevol: iemand die begrijpt waar je tegenaan loopt, en die ervaring heeft met het leven met een hulphond.',
      },
      { type: 'heading', content: 'De vraag' },
      {
        type: 'paragraph',
        content:
          'Er was behoefte aan één vaste plek waar leden elkaar kunnen vinden, contact kunnen houden en vragen kunnen stellen. Geen openbaar forum op internet en geen losse appgroepen, maar een eigen omgeving voor deze groep.',
      },
      { type: 'heading', content: 'Onze aanpak' },
      {
        type: 'list',
        items: [
          'Een eigen app voor de leden, in plaats van een algemeen platform waar ook anderen meelezen.',
          'Een rustige, overzichtelijke vormgeving, zodat de app prettig en laagdrempelig is om te gebruiken.',
          'Ruimte om vragen te stellen en op elkaar te reageren, zodat kennis en ervaring binnen de groep gedeeld worden.',
          'Gebouwd als maatwerk webapplicatie, zodat de app aansluit op wat deze groep nodig heeft.',
        ],
      },
      { type: 'heading', content: 'Het resultaat' },
      {
        type: 'paragraph',
        content:
          'Oud-dienders met een hulphond hebben een eigen plek om contact te houden met elkaar en hun vragen te stellen aan mensen die hun situatie kennen.',
      },
      {
        type: 'callout',
        content:
          'Soms is de beste software niet de meest ingewikkelde, maar de plek waar mensen zich begrepen voelen.',
      },
    ],
  },
]
